import React, { useEffect, useState } from "react";
import Map from "./Map";
import { apiClient } from "../api_client";
import { useParams, useNavigate, useLocation } from "react-router-dom";

export default function EntrantDetails({ eventId }) {
  const [points, setPoints] = useState([]);
  const { entrantId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  
  const entrantName = location.state?.entrantName;
  const raceNumber = location.state?.raceNumber;

  useEffect(() => {
    let isMounted = true;

    const fetchLocation = async () => {
      try {
        const data = await apiClient.entrants.getLocation(eventId, entrantId);
        if (!isMounted || !data?.points) return;

        setPoints(prevPoints => {
          const lastTime = prevPoints.length
            ? prevPoints[prevPoints.length - 1].t
            : null;

          const newPoints = data.points.filter(
            p => !lastTime || p.t > lastTime
          );

          if (newPoints.length === 0) return prevPoints;

          return [...prevPoints, ...newPoints];
        });
      } catch (err) {
        console.error(err);
      }
    };

    fetchLocation();

    const interval = setInterval(fetchLocation, 10000); // fetch every 10 seconds
    return () => {
      isMounted = false;
      clearInterval(interval);
    };
  }, [entrantId, eventId]);

  const goBack = () => {
    navigate(`/events/${eventId}/still_racing`);
  };

  return (
    <div>
      <h2>
        Location data for{" "}
        <span style={{ color: "#0d6efd", fontWeight: 600 }}>
          {entrantName ?? `Racer ${entrantId}`}
        </span>
      </h2>

      {raceNumber && (
        <h3>
          Bib{" "}
          <span style={{ color: "#198754", fontWeight: 600 }}>
            #{raceNumber}
          </span>
        </h3>
      )}

      <button
        onClick={goBack}
        className="btn btn-primary"
        style={{ marginBottom: "1rem" }}
      >
        ← Back to Race Status
      </button>

      {points.length === 0 ? (
        <p>No location data found</p>
      ) : (
        <Map points={points} />
      )}
    </div>
  );
}
